import axios from 'axios';
import { URL_GET_CONTACT_LIST } from 'constants/urls';

const getContactList = async () => {
	const { data } = await axios({
		method: 'GET',
		url: URL_GET_CONTACT_LIST,
		headers: { 'Content-Type': 'application/json;charset=UTF-8' },
	});
	return data;
};

export default getContactList;
